import { Box, makeStyles, Theme } from "@material-ui/core"
import classNames from "classnames"
import React, { PropsWithChildren, useState } from "react"
import { ReactComponent as CloseIcon } from "../../components/svgs/Close.svg"
import usePlatform from "../../hooks/usePlatform"

interface StyleProps {
  clickable?: boolean
  backgroundColor: string
}

const useStyle = makeStyles<Theme, StyleProps>((theme) => ({
  root: {
    cursor: ({ clickable }) => (clickable ? "pointer" : "default"),
    backgroundColor: ({ backgroundColor }) => backgroundColor,
    position: "relative",
    minHeight: "48px",
    padding: "12px",
    letterSpacing: "-0.02em",
  },
  removeButton: {
    cursor: "pointer",
    backgroundColor: "transparent",
    border: "none",
    outline: "none",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: "10px",
    [theme.breakpoints.up("md")]: {
      position: "absolute",
      right: "18px",
    },
  },
  chip: {
    backgroundColor: ({ backgroundColor }) => backgroundColor,
    width: "fit-content",
    height: "fit-content",
    padding: "3px",
    borderRadius: "4px",
    color: "#FFFFFF",
    letterSpacing: "-0.02em",
    fontWeight: 700,
    fontSize: "10px",
    lineHeight: "13px",
    [theme.breakpoints.up("md")]: {
      fontSize: "12px",
      lineHeight: "15px",
      padding: "4px",
    },
  },
}))

interface Props {
  className?: string
  backgroundColor: string
  removable?: boolean
  onClick?: () => void
  onRemove?: () => void
}

export default function BarBanner({
  children,
  className,
  backgroundColor,
  removable = false,
  onClick,
  onRemove,
}: PropsWithChildren<Props>) {
  const { isMobile } = usePlatform()
  const classes = useStyle({ clickable: Boolean(onClick), backgroundColor })
  const [isVisible, setIsVisible] = useState(true)

  if (!isVisible) return null

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems={isMobile ? "flex-start" : "center"}
      className={classNames([classes.root, className])}
      onClick={onClick}>
      {children}
      {removable && (
        <button
          type="button"
          className={classNames(["BarBanner-removeButton", classes.removeButton])}
          onClick={(e) => {
            e.stopPropagation()
            setIsVisible(false)
            onRemove && onRemove()
          }}>
          <CloseIcon width={12} height={12} />
        </button>
      )}
    </Box>
  )
}

interface TitleChipProps {
  className?: string
  backgroundColor: string
}

function TitleChip({ className, backgroundColor, children }: PropsWithChildren<TitleChipProps>) {
  const classes = useStyle({ backgroundColor })

  return (
    <Box display="flex" justifyContent="center" alignItems="center" className={classNames([classes.chip, className])}>
      {children}
    </Box>
  )
}

BarBanner.TitleChip = TitleChip
